/** LocalForage key for the individual-license admin grid. */
export const INDIVIDUAL_LICENSE_GRID_STATE_ID: string = 'licensing-individual-license';

/** LocalForage key for the organization-license admin grid. */
export const ORGANIZATION_LICENSE_GRID_STATE_ID: string = 'licensing-organization-license';

/** LocalForage key for the roles catalog list grid. */
export const ROLES_LIST_GRID_STATE_ID: string = 'licensing-roles-list';

/** LocalForage key for the role detail assignees grid. */
export const ROLE_DETAIL_USERS_GRID_STATE_ID: string = 'licensing-role-detail-users';

/** LocalForage key for the role detail flat permissions grid. */
export const ROLE_DETAIL_PERMISSIONS_FLAT_GRID_STATE_ID: string = 'licensing-role-detail-permissions-flat';

/** LocalForage key for per-area permission matrix grids on role detail (ungrouped flat matrix). */
export const ROLE_DETAIL_AREA_MATRIX_GRID_STATE_ID: string = 'licensing-role-detail-area-matrix';
